import Vue from 'vue'
import Header from './header.vue'
import Footer from './footer.vue'
import TopMenu from './topMenu.vue'
import TopTabs from './topTabs.vue'
import Consult from './consult.vue'
import EditAddress from './editAddress.vue'
import Service from './service.vue'
import service_top from './service_top.vue'
import Back from './back.vue'
import SearchBar from './searchBar.vue'
import StatusIcon from './statusIcon.vue'
import headerPhone from './headerPhone.vue'

const components = [
  Header,
  Footer,
  TopMenu,
  TopTabs,
  Consult,
  EditAddress,
  Service,
  service_top,
  Back,
  SearchBar,
  StatusIcon,
  headerPhone
]

components.forEach(function (component) {
  Vue.component(component.name, component)
})



// WEBPACK FOOTER //
// ./src/components/global.js